import { render, staticRenderFns } from "./frequently-asked-questions.vue?vue&type=template&id=9a7abac4"
import script from "./frequently-asked-questions.vue?vue&type=script&lang=js"
export * from "./frequently-asked-questions.vue?vue&type=script&lang=js"
import style0 from "./frequently-asked-questions.vue?vue&type=style&index=0&id=9a7abac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports